import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { constants } from 'src/ajs-app/app.constants.js';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { SitesService } from 'src/app/mobile/shared/sites.service';
import { SiteV2 } from 'src/app/shared/models';
import { ErrorHandlingService } from 'src/app/shared/services/error-handling.service';
import { AccountInformation } from './shared/models/account-information.model';

@Injectable({
  providedIn: 'root',
})
export class AccountsService {
  twitterSites: SiteV2[] = [];
  twitterSiteType: number;
  eligibleGroups = [];

  constructor(
    private httpClient: HttpClient,
    private alcmeonContext: AlcmeonContextService,
    private errorHandlingService: ErrorHandlingService,
    private sitesService: SitesService,
    @Inject('$state') private $state: any,
    @Inject('TwitterFactory') private twitterService: any
  ) {}

  getAccountInfo(siteId): Observable<AccountInformation> {
    return of(this.sitesService.sitesV2).pipe(
      map((accounts: SiteV2[]) => {
        this.twitterSiteType = this.twitterService.getType();
        return (accounts || []).filter(account => account.type === this.twitterSiteType);
      }),
      tap(result => (this.twitterSites = result.sort((a, b) => (a.name || '').localeCompare(b.name || '')))),
      switchMap(() =>
        this.httpClient.get<AccountInformation>(
          `${constants.baseUrl}api/1.0/companies/${this.alcmeonContext.companyId}/sites/${siteId}`
        )
      )
    );
  }

  updateAccountInformation(siteId: number, model: Partial<AccountInformation>) {
    return this.httpClient
      .put(`${constants.baseUrl}api/1.0/companies/${this.alcmeonContext.companyId}/sites/${siteId}`, model)
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  updateKakaotalkEngagementInformation(siteId: number, model: { sender_key: string }) {
    return this.httpClient
      .put(
        `${constants.baseUrl}api/1.0/companies/${this.alcmeonContext.companyId}/sites/${siteId}/kakaotalk/sender-key`,
        model
      )
      .pipe(this.errorHandlingService.catchAlertAndThrowHttpError());
  }

  redirectToAccountsPage($state) {
    this.$state.go('auth.alcmeon.fuse.parameters.accounts', {
      companyId: $state.params.companyId,
    });
  }
}
